import { isUndefined } from 'lodash-es';

export function removeTransparentBorder(
  ctx: CanvasRenderingContext2D,
  strokeColor: string,
) {
  if (strokeColor === 'transparent') {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.stroke();
    ctx.globalCompositeOperation = 'source-over';
  } else if (!isUndefined(strokeColor)) {
    ctx.strokeStyle = strokeColor;
    ctx.stroke();
  }
}
